export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';

export const BASE_URL = process && process.env ? process.env.REACT_APP_BASE_URL : 'http://api.shopql.com/';
